<template>
    <PageSidebar>
        <template #sidebarTitle>
            <div class="space-x-3">
                <ButtonSecondaryIconSm @click="handleQuit">
                    <ArrowLeftIcon />
                </ButtonSecondaryIconSm>
                <span>{{ social.title }}</span>
            </div>
        </template>
        <template #sidebarMain>
            <div class="p-6 space-y-5">
                <component :is="social.icon" class="w-6 h-6 text-primary" />
                <FormInput :title="$t('shared.url')" v-model="social.url" />
                <FormToggleSm :title="$t('legal.socials.show_social')" v-model="social.enabled" />
            </div>
        </template>
        <template #sidebarFooter>
            <cSaveButton
                @save="$emit('save')"
                :disabled="!isDirty"
                :ctaDisabled="$t('shared.save')"
            />
        </template>
    </PageSidebar>
</template>

<script>
import { PageSidebar } from "@easy/ui/page-components";
import { ButtonSecondaryIconSm } from "@easy/ui/buttons";
import { ArrowLeftIcon } from "@easy/ui/icons";
import { FormInput, FormToggleSm } from "@easy/ui/forms";
import { useSaveOrDropModal } from "@/store/useSaveOrDropModal";
import cSaveButton from "@/shared/components/cSaveButton.vue";

export default {
    components: {
        PageSidebar,
        ButtonSecondaryIconSm,
        ArrowLeftIcon,
        FormInput,
        FormToggleSm,
        cSaveButton,
    },
    props: {
        social: {
            type: Object,
            required: true,
        },
        backupData: {
            type: Object,
            required: true,
        },
    },
    emits: ["save", "cancel"],
    setup() {
        const { askToConfirmIfNeeded } = useSaveOrDropModal();
        return {
            askToConfirmIfNeeded,
        };
    },
    computed: {
        isDirty() {
            return (
                this.social.url !== this.backupData.url ||
                this.social.enabled !== this.backupData.enabled
            );
        },
        socialUrl() {
            return this.social.url;
        },
        socialEnabled() {
            return this.social.enabled;
        },
    },
    watch: {
        socialUrl: function (value) {
            if (value) {
                this.social.enabled = true;
            } else {
                this.social.enabled = false;
            }
            this.social.changeUrl(value);
        },
        socialEnabled: function (value) {
            this.social.changeEnabled(value);
        },
    },
    methods: {
        async handleQuit() {
            const result = await this.askToConfirmIfNeeded({
                showModal: this.isDirty,
                onConfirmChanges: () => this.$emit("save"),
            });
            if (!result) {
                this.$emit("cancel");
            }
        },
    },
};
</script>
